<template>
    <div class="category-promo my-7">
        <v-row class="justify-center text-center">
            <div class="font-weight-bold ml-2 headline">
                {{ currentCategory.name }}                
            </div>
        </v-row>

        <v-row class="justify-center text-center mt-3 mb-3">
            <div class=" ml-2 headline">
                Celkem jste přispěli <span class="font-weight-bold">{{ formatThousands(projectTotalAmount) }}</span> Kč.
            </div>
        </v-row>

        <v-row class="text-sm-left text-center">
            <v-col cols="12" class="text-justify">
                <div v-if="currentCategory.description"
                    v-html="currentCategory.description"></div>            
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="6" lg="6" sm="12" v-for="product in allProducts" :key="product.id">
                <v-img
                        :src="product.imageUrl"
                        contain
                        max-height="287"
                        max-width="573"
                        class="mx-auto"
                >
                    <div class="image-caption d-flex justify-end align-end">
                        <v-btn fab v-if="product.isGiftCard" :to="'/gift-product/' + product.alias">
                            <v-icon color="primary">mdi-gift</v-icon>
                        </v-btn>
                        <img class="ml-3" :src="require('../../assets/button.png')" @click="openDialog(product)" />
                    </div>
                </v-img>
            </v-col>
        </v-row>

    <v-dialog
        v-model="dialog"
        persistent
        max-width="590"
        :fullscreen="$vuetify.breakpoint.xsOnly">
      <v-card>
        <v-card-title class="headline"> Koupit stravenku </v-card-title>
        <v-card-text v-html="currentProduct.description"></v-card-text>
        <v-card-text>
          <v-layout column class="text-center">
            <div class="subtitle-1">Množství stravenek</div>
            <vue-numeric-input
                v-model="qty"
                :min="1"
                :max="10"
                align="center"
                size="100px"
                class="mx-auto"
            ></vue-numeric-input>
          </v-layout>
          <v-layout column class="text-center mt-2">
            <div class="subtitle-1">
              Celková cena:
              <strong>{{ qty * currentProduct.amountWithVat }}</strong> Kč
            </div>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" depressed @click="dialogClose"> Zavřít </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="success" depressed @click="dialogAddToCart()">
            Přidat do košíku
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import {formatThousands} from '../../Helper'
    import VueNumericInput from "vue-numeric-input";

    export default {
        name: 'Promo',
        components: {
            VueNumericInput,
        },
        mixins: [formatThousands],
        data () {
            return {
                dialog: false,
                currentProduct: {},
                qty: 1,
                primary: window.primary,
                secondary: window.secondary
            }
        },
        mounted () {
           this.$store.dispatch('getProjectTotalAmount');            
        },
        computed: {
            ...mapGetters(["allProducts", "currentCategory", "projectTotalAmount"]),
            imageUrl() {
                return process.env.VUE_APP_ROOT_API;
            }
        },
        methods: {
            ...mapActions([
                'addToCart'
            ]),
            openDialog(product) {
                this.currentProduct = product;
                this.dialog = true;
            },
            dialogAddToCart() {
                this.addToCart({ product: this.currentProduct, qty: this.qty });
                this.dialogClose();
            },
            dialogClose() {
                this.dialog = false;
                this.qty = 1;
                this.currentProduct = {};
            },
        }
    }
</script>

<style lang="scss">
    .category-promo {
        .image-caption {
            bottom: 0;
            position: absolute;
            padding: 9px;
            right: 0;
            cursor: pointer;
        }
    }
</style>
